module.exports = __webpack_public_path__ + "img/pause-icon.7c9d2c1f.svg";